'use client';

import { useCallback } from 'react';

import { ArrowRightIcon } from 'lucide-react';

interface SpitexFinalCtaProps {
  side: 'supply' | 'demand';
}

const ctaContent = {
  supply: {
    headline: 'Bereit fuer den naechsten Karriereschritt?',
    subheadline:
      'Bewerben Sie sich in 5 Minuten und erhalten Sie innerhalb einer Woche passende Einsatzangebote.',
    ctaLabel: 'Jetzt bewerben',
  },
  demand: {
    headline: 'Wir finden die Spitex, die zu Ihnen passt',
    subheadline:
      'Stellen Sie jetzt Ihre unverbindliche Anfrage. Wir melden uns innert einer Stunde.',
    ctaLabel: 'Jetzt kostenlos anfragen',
  },
};

export function SpitexFinalCta({ side }: SpitexFinalCtaProps) {
  const content = ctaContent[side];

  const handleClick = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    document
      .getElementById('lead-form')
      ?.scrollIntoView({ behavior: 'smooth' });
  }, []);

  return (
    <section className="w-full px-4 py-16 sm:py-24">
      <div className="mx-auto max-w-3xl text-center">
        <h2 className="text-foreground text-2xl font-bold sm:text-3xl lg:text-4xl">
          {content.headline}
        </h2>
        <p className="text-muted-foreground mx-auto mt-4 max-w-xl text-lg">
          {content.subheadline}
        </p>

        <div className="mt-8">
          <a
            href="#lead-form"
            onClick={handleClick}
            className="inline-flex h-14 items-center gap-2 rounded-xl px-8 text-base font-semibold text-white shadow-lg transition-all hover:brightness-110"
            style={{ backgroundColor: 'var(--landing-primary)' }}
          >
            {content.ctaLabel}
            <ArrowRightIcon className="h-5 w-5" />
          </a>
        </div>

        <p className="text-muted-foreground mt-4 text-sm">
          Kostenlos und unverbindlich. Keine versteckten Gebuehren.
        </p>
      </div>
    </section>
  );
}
